import React from 'react';
import { useTranslation } from 'react-i18next';
import Router from 'next/router';
import { useBridgeState } from '@digitaz/bridge-sdk-client';

interface DesktopSwitcherProps {
  className?: string;
}

export const DesktopSwitcher: React.FC<DesktopSwitcherProps> = ({
  className
}) => {
  const { t } = useTranslation();
  const { isWebView } = useBridgeState();

  const desktopLinkOnClickHandler = (e: React.MouseEvent) => {
    e.preventDefault();
    const domain = process.env.COOKIES_DOMAIN || '.bina.az';
    const date = new Date();
    const setCookie = (name: string, expiresDate: Date) => {
      document.cookie = `${name}; expires=${expiresDate.toUTCString()}; domain=${domain}`;
    };
    setCookie('mobile_site= ', new Date(0));
    date.setDate(date.getDate() + 1);
    setCookie('force_desktop_site=yes', date);
    Router.reload();
  };

  if (isWebView) {
    return null;
  }

  return (
    <button
      onClick={desktopLinkOnClickHandler}
      className={className}
      data-cy="menu-link"
    >
      {t('desktop_switcher.full_site')}
    </button>
  );
};
